import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Database18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      d='M4 7C4.55228 7 5 6.55228 5 6C5 5.44772 4.55228 5 4 5C3.44772 5 3 5.44772 3 6C3 6.55228 3.44772 7 4 7Z'
      fill='currentColor'
    />
    <path d='M8 5.25H14V6.75H8V5.25Z' fill='currentColor' />
    <path
      d='M5 12C5 12.5523 4.55228 13 4 13C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11C4.55228 11 5 11.4477 5 12Z'
      fill='currentColor'
    />
    <path d='M14 11.25H8V12.75H14V11.25Z' fill='currentColor' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.563851 9C0.360926 8.70857 0.25 8.36 0.25 8V3.5C0.25 2.81917 0.819167 2.25 1.5 2.25H16.5C17.1808 2.25 17.75 2.81917 17.75 3.5V8C17.75 8.36 17.6391 8.70857 17.4361 9.00001C17.6391 9.29144 17.75 9.64 17.75 10V14.5C17.75 15.1808 17.1808 15.75 16.5 15.75H1.5C0.819166 15.75 0.25 15.1808 0.25 14.5V10C0.25 9.64 0.360926 9.29143 0.563851 9ZM1.75 8V3.75H16.25V8C16.25 8.13261 16.1326 8.25 16 8.25H2C1.86739 8.25 1.75 8.13261 1.75 8ZM2 9.75C1.86739 9.75 1.75 9.86739 1.75 10V14.25H16.25V10C16.25 9.86739 16.1326 9.75 16 9.75H2Z'
      fill='currentColor'
    />
  </Svg>
);

Database18.displayName = 'Database18';
export default Database18;
